import Vue from "vue";

import serenityLogo from "@/assets/svg/serenity-logo.svg";
import pulseLogo from "@/assets/svg/pulse-logo.svg";

Vue.component("serenityLogoSvg", serenityLogo);
Vue.component("pulseLogoSvg", pulseLogo);
